import { Check, Crown, Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

const usd = (n) => `$${(Number(n) || 0).toFixed(2)}`;

// Fan-facing tier card. Used by the creator's "Preview as fan" view (preview) and the
// fan subscribe page (onSubscribe). Read-only when neither is provided.
export function TierCard({ tier, isCurrent, onSubscribe, subscribing, preview }) {
  const perks = tier.perks || [];
  return (
    <div
      className={cn(
        "flex flex-col rounded-2xl border p-5",
        isCurrent ? "border-bloq-mint/40 bg-bloq-mint/[0.06]" : "border-white/10 bg-bloq-s2"
      )}
      data-testid={`fan-tier-${tier.id}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-bloq-purple/15 text-bloq-purple">
              <Crown className="h-4 w-4" />
            </span>
            <span className="truncate text-base font-bold text-white" data-testid={`fan-tier-name-${tier.id}`}>{tier.name}</span>
          </div>
        </div>
        {isCurrent && (
          <span className="shrink-0 rounded-full border border-bloq-mint/30 bg-bloq-mint/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-bloq-mint" data-testid={`fan-tier-current-${tier.id}`}>
            Current
          </span>
        )}
      </div>

      <div className="mt-3 flex items-baseline gap-1">
        <span className="text-3xl font-extrabold text-white" data-testid={`fan-tier-price-${tier.id}`}>{usd(tier.price_usd)}</span>
        <span className="text-sm text-bloq-muted">/ month</span>
      </div>

      {tier.description && <p className="mt-2 text-sm text-white/80">{tier.description}</p>}

      {perks.length > 0 && (
        <ul className="mt-3 space-y-1.5">
          {perks.map((p, i) => (
            <li key={i} className="flex items-start gap-2 text-sm text-white/85">
              <Check className="mt-0.5 h-4 w-4 shrink-0 text-bloq-mint" />
              <span>{p}</span>
            </li>
          ))}
        </ul>
      )}

      <div className="mt-auto pt-4">
        {preview ? (
          <Button disabled className="w-full rounded-full bg-bloq-purple/60 font-bold text-white disabled:opacity-70" data-testid={`fan-tier-subscribe-preview-${tier.id}`}>
            Subscribe
          </Button>
        ) : isCurrent ? (
          <Button disabled className="w-full rounded-full border border-bloq-mint/30 bg-transparent font-bold text-bloq-mint disabled:opacity-100" data-testid={`fan-tier-current-btn-${tier.id}`}>
            <Check className="mr-1 h-4 w-4" /> Your tier
          </Button>
        ) : onSubscribe ? (
          <Button
            onClick={() => onSubscribe(tier)}
            disabled={subscribing}
            className="w-full rounded-full bg-bloq-purple font-bold text-white hover:bg-bloq-purple/90 disabled:opacity-60"
            data-testid={`fan-tier-subscribe-${tier.id}`}
          >
            {subscribing ? <Loader2 className="h-5 w-5 animate-spin" /> : "Subscribe"}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
